import { PolymorphicComponentProps } from "@omni/types/components/utils/polymorphic.types";
import { cn } from "@omni/utils/styles";
import React from "react";

export type FormGroupComponentProps = {
    disabled?: boolean;
    toggle?: boolean;
    inline?: boolean;
};

export type FormGroupProps<T extends React.ElementType> =
    PolymorphicComponentProps<T, FormGroupComponentProps, "div" | "fieldset">;

const FormGroup = <T extends React.ElementType = "div">({
    className,
    disabled,
    toggle,
    inline,
    tag,
    ...attributes
}: FormGroupProps<T>) => {
    const Tag = tag || ("div" as React.ElementType);

    const classes = cn(
        {
            "tw:block": !inline,
            "tw:inline-block": inline
        },
        {
            "tw:group/formgrouptoggle tw:pl-5 tw:relative": toggle,
            "tw:group/formgroup tw:mb-4": !toggle
        },
        className
    );

    return (
        <Tag
            {...attributes}
            className={classes}
        />
    );
};

export { FormGroup };
